import {put,takeLatest,call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";

import {
    GET_PROMOTION,
    GET_PROMOTION_SUCCESS,
    GET_PROMOTION_ERROR
}
    from "../../../actions/menu/promotions";

function* getPromotionSaga(action) {
    try {
        const data=yield call(promotionService.GetPromotion,action.payload)
        yield put({
            type: GET_PROMOTION_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_PROMOTION_ERROR,error: error.data
        });
    }
}


export function* getPromotionSagaWatcher() {
    yield takeLatest(GET_PROMOTION,getPromotionSaga);
}